import * as React from "react";
import {RaisedButton} from "../common/RaisedButton";
import {defaultButtonStyle} from "../common/buttonStyles";
import {navigateTo} from "../../../navigateTo";
import {FormattedMessage} from "react-intl";
import {getTranslation} from "../../utils/translationUtil";

export const DOCUMENTS_DESCRIPTION = "Get documents shared by your consultant";
export const HomeSharedDocuments: React.FunctionComponent = () => {
    const renderSharedDocumentsButton = () => {
        return <RaisedButton
            className="home-shared-documents__documents-button"
            style={ defaultButtonStyle }
            onClick={() => navigateTo("/shared-documents")}
            primary={true}
        >
            <FormattedMessage id="product.documents" defaultMessage="Documents" />
        </RaisedButton>;
    };

    return <div className="home-shared-documents__container">
        <div className="home-shared-documents__icon"/>
        <div className="home-documents-research__title-container">
            <div className="home-documents-research__title">
                {getTranslation("header.shared-documents", "Shared Documents")}
            </div>
            <div className="home-documents-research__description">
                {getTranslation("home.shared-documents.description", DOCUMENTS_DESCRIPTION)}
            </div>
            <div className="home-shared-documents__button-container">{renderSharedDocumentsButton()}</div>
        </div>
    </div>;
};